const ModuleName = "md_input";
const ModuleDefaults = {
  inputStyle: "",
  autoRender: false,
  required: false,
  title: "姓名",
  placeholder: "請輸入姓名",
  whenkeyup(e) {
    console.log("when keyup");
  },
  whenFocus(e) {
    console.log("when focus");
  },
  whenBlur(e) {
    console.log("when blur");
  },
};

class Module {
  constructor(ele, options) {
    this.ele = ele;
    this.$ele = $(ele);
    this.option = options;

    this.$input = this.$ele.find("input");
    this.$input_wrap = this.$ele.find(".md_input_input_wrap");
    this.$errorMsg = this.$ele.find(".md_input_errormsg");
  }

  init() {
    if (this.option.autoRender === true) {
      this.renderHtml();
    }
    this.render();
    this.registInputKeyupEvent();
    // this.registFocusEvent();
    // this.registBlurEvent();
    this.registTriggerErrorEvent();
    this.registTriggerClearErrorEvent();
  }

  renderHtml() {
    let self = this;
    const reqClass = self.option.required ? "req" : "";
    const html = `
     <label class="md_input_label">
        <div class="md_input_title ${reqClass}">${self.option.title}</div>
        <div class="md_input_input_wrap">
          <input type="text" placeholder="${self.option.placeholder}" class="md_input_current" />
        </div>
        <span class="md_input_errormsg">錯誤訊息錯誤訊息</span>
      </label>
    `;
    self.$ele.append(html);

    // 重新獲取元素
    self.$input = self.$ele.find("input");
    self.$input_wrap = self.$ele.find(".md_input_input_wrap");
    self.$errorMsg = self.$ele.find(".md_input_errormsg");
  }

  render() {
    let self = this;
    if (self.option.inputStyle === "outline") {
      self.$ele.addClass("outline");
    }
    if (self.option.inputStyle === "background") {
      self.$ele.addClass("background");
    }
    if (self.option.inputStyle === "icon") {
      self.$ele.addClass("icon");
    }

    this.registFocusEvent();
    this.registBlurEvent();
  }

  registInputKeyupEvent() {
    let self = this;
    self.$input.on("keyup", (e) => {
      if (self.option.whenkeyup) self.option.whenkeyup(e);
    });
  }

  registFocusEvent() {
    let self = this;
    self.$input.on("focus", (e) => {
      if (self.option.whenFocus) self.option.whenFocus(e);
    });
  }

  registBlurEvent() {
    let self = this;
    self.$input.on("blur", (e) => {
      if (self.option.whenBlur) self.option.whenBlur(e);
    });
  }

  registTriggerErrorEvent() {
    let self = this;
    this.$ele.on("onError", (e, errorMessage) => {
      if (self.$input_wrap && self.$input_wrap.length > 0) {
        // @ts-ignore
        self.$input_wrap.focus();
        self.$input_wrap.addClass("errorFocus");
        self.$input_wrap.addClass("error");

        // 同時處理input元素
        if (self.$input && self.$input.length > 0) {
          self.$input.addClass("error");
        }

        // 處理錯誤訊息
        const $errorMsg = self.$ele.find(".md_input_errormsg");
        if ($errorMsg.length > 0) {
          $errorMsg.addClass("error");

          // 如果提供了自定義錯誤訊息，則更新錯誤訊息內容
          if (errorMessage) {
            $errorMsg.text(errorMessage);
          }
        }

        // 滾動功能
        if (typeof self.ele.scrollIntoView === "function") {
          self.ele.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    });
  }

  registTriggerClearErrorEvent() {
    let self = this;
    this.$ele.on("clearError", () => {
      if (self.$input_wrap && self.$input_wrap.length > 0) {
        self.$input_wrap.removeClass("errorFocus");
        self.$input_wrap.removeClass("error");
      }

      if (self.$input && self.$input.length > 0) {
        self.$input.removeClass("error");
      }

      if (self.$errorMsg && self.$errorMsg.length > 0) {
        self.$errorMsg.removeClass("error");
      }
    });
  }
}

$.fn[ModuleName] = function (options) {
  return this.each(function () {
    var $this = $(this);
    var module = $this.data(ModuleName);
    var opts = null;
    if (module) {
      if (typeof options === "string") {
        module[options]();
      } else {
        throw "unsupported options!";
      }
    } else {
      opts = $.extend({}, ModuleDefaults, typeof options === "object" && options);
      module = new Module(this, opts);
      $this.data(ModuleName, module);
      module.init();
    }
  });
};
